import { FiltersForm } from '@jobcost-monorepo/ui';
import { ReactElement, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IBaseModel, IListFetchParams, useListContext } from '../../../common';
import { generateFilterForm } from '../../../utils';
import React from 'react';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

const GridFilters = <T extends IBaseModel, Q extends IListFetchParams>({
  isOpen,
  handleClose,
}: Props): ReactElement => {
  const methods = useForm<Q>();
  const { params, repository, fetchDataList } = useListContext<T, Q>();

  const { getValues } = methods;

  const handleResetFilters = async () => {
    methods.reset();
    await fetchDataList({
      skip: params?.skip,
      take: params?.take,
      search: params?.search,
    } as Q);
  };

  const handleFilter = async () => {
    const data = getValues();
    await fetchDataList({ ...params, ...data });
    handleClose();
  };

  useEffect(() => {
    methods.reset(params);
  }, [params, methods]);

  return (
    <FiltersForm
      isOpen={isOpen}
      handleClose={handleClose}
      handleResetFilters={handleResetFilters}
      handleFilter={handleFilter}
    >
      <FormProvider {...methods}>
        <div className="p-4">
          {generateFilterForm<T, Q>(repository.gridFiltersOptions)}
        </div>
      </FormProvider>
    </FiltersForm>
  );
};

export default GridFilters;
